(function () {
    'use strict';

    function simpleSearchController($scope, $rootScope) {
        var vm = this;
        vm.results = [];

        $scope.$watch(function () {
            return vm.results;
        }, function (newVal) {
            if (newVal && newVal.length > 0) {
                vm.busy = false;
                $rootScope.$broadcast('simpleSearchResultsUpdated', { results: vm.results });
            }
        });

        $rootScope.$on('noMoreResults', function (event, args) {
            if (args.datasetName === vm.datasetName) {
                console.log('stopping get more results');
                vm.nextResults = function () {};
            }
        })

        vm.nextResults = (function () {
            vm.busy = true;
            console.log('get more');
            $rootScope.$broadcast('getNextResults', { datasetName: vm.datasetName })
        })

        $scope.init = function (datasetName) {
            if (!datasetName) {
                throw Error('Simple search must be initialized with an name');
            }

            vm.datasetName = datasetName;
        }

    }

    simpleSearchController.$inject = ['$scope', '$rootScope'];

    angular.module('ecap.common').controller('simpleSearchController', simpleSearchController);
})();